module.exports = __webpack_public_path__ + "media/images/icons/download-aa7703bf290609596d27b0daeb165432.svg";